import React from 'react'
import WithLoadingErrorWrapper from '@/components/with-loading-error-wrapper'
import { useTenant } from '@/hooks'
import { useGetPublicSkillFrameworkQuery } from '@/state/skills'
import type { ApiErrorResponse } from '@/types'
import clsx from 'clsx'

interface Props {
  selectedFrameworks: number[]
  onToggle: (id: number) => void
}

const PublicFrameWorks: React.FC<Props> = ({ selectedFrameworks, onToggle }) => {
  const { tenant } = useTenant()

  const { data: skillFrameworks, isLoading, error, refetch } =
    useGetPublicSkillFrameworkQuery(
      { tenant: tenant! },
      { skip: !tenant }
    )

  return (
    <WithLoadingErrorWrapper
      error={error as ApiErrorResponse}
      loading={isLoading}
      onRetry={refetch}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {skillFrameworks
          ?.filter((f) => !selectedFrameworks.includes(f.id))
          .map((framework) => {
            return (
              <div
                key={framework.id}
                onClick={() => onToggle(framework.id)}
                className={clsx(
                  "cursor-pointer rounded-xl border p-5 transition-all duration-200",
                  "hover:shadow-md hover:border-primary border-muted"
                )}
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-sm">
                    {framework.name}
                  </h3>
                </div>
              </div>
            )
          })}
      </div>
    </WithLoadingErrorWrapper>
  )
}

export default PublicFrameWorks